// src/pages/VistaPrincipal.js
import React, { useState } from 'react';

function VistaPrincipal() {
  const [textoPrincipal, setTextoPrincipal] = useState('');
  const [textoSecundario, setTextoSecundario] = useState('');
  const [imagen, setImagen] = useState(null);
  const [informacionPrincipal, setInformacionPrincipal] = useState('');
  const [precio, setPrecio] = useState('');

  // Maneja el submit sin guardar en backend
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Datos de vista principal (no guardados):', {
      textoPrincipal,
      textoSecundario,
      imagen,
      informacionPrincipal,
      precio,
    });
    // Podrías mostrar un alert o algo similar
  };

  // Cuando se seleccione la imagen
  const handleImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImagen(e.target.files[0]);
    }
  };

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <h4 className="py-3">Vista Principal</h4>

      <form onSubmit={handleSubmit}>
        <div className="row g-4">
          {/* Card 1: Texto principal y secundario */}
          <div className="col-md-6">
            <div className="card">
              <h5 className="card-header">Textos</h5>
              <div className="card-body">
                {/* Texto principal */}
                <div className="mb-3">
                  <label htmlFor="textoPrincipal" className="form-label">
                    Texto principal
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="textoPrincipal"
                    placeholder="Ej. Bienvenido a nuestra página"
                    value={textoPrincipal}
                    onChange={(e) => setTextoPrincipal(e.target.value)}
                  />
                </div>

                {/* Texto secundario */}
                <div className="mb-3">
                  <label htmlFor="textoSecundario" className="form-label">
                    Texto secundario
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="textoSecundario"
                    placeholder="Ej. Los mejores precios del mercado"
                    value={textoSecundario}
                    onChange={(e) => setTextoSecundario(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Card 2: Imagen recomendada 1920x934 */}
          <div className="col-md-6">
            <div className="card">
              <h5 className="card-header">Imagen (1920 x 934)</h5>
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="imagen" className="form-label">
                    Seleccionar imagen
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="imagen"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  <small className="text-muted">
                    Se recomienda 1920×934 píxeles.
                  </small>
                </div>

                {/* Previsualización (opcional) */}
                {imagen && (
                  <div className="mt-3">
                    <p className="mb-1">Previsualización:</p>
                    <img
                      src={URL.createObjectURL(imagen)}
                      alt="Vista"
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxHeight: '200px',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Card 3: Información principal y precio */}
          <div className="col-md-12">
            <div className="card">
              <h5 className="card-header">Información adicional</h5>
              <div className="card-body">
                {/* Información principal */}
                <div className="mb-3">
                  <label htmlFor="informacionPrincipal" className="form-label">
                    Información principal
                  </label>
                  <textarea
                    className="form-control"
                    id="informacionPrincipal"
                    rows={3}
                    placeholder="Texto descriptivo, reseña o información clave..."
                    value={informacionPrincipal}
                    onChange={(e) => setInformacionPrincipal(e.target.value)}
                  ></textarea>
                </div>

                {/* Precio */}
                <div className="mb-3">
                  <label htmlFor="precio" className="form-label">
                    Precio
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="precio"
                    placeholder="Ej. 999.99"
                    value={precio}
                    onChange={(e) => setPrecio(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botón Guardar */}
        <div className="mt-4 d-flex justify-content-end">
          <button type="submit" className="btn btn-primary">
            Guardar
          </button>
        </div>
      </form>
    </div>
  );
}

export default VistaPrincipal;
